import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Container, TextField, Alert, Pagination, Grid, InputAdornment, Modal, Fade, Box, Typography } from '@mui/material';
// components
import Page from '../components/Page';
import Loader from "./Loader";
import { DashboardSort, DashboardList,PublishedDashboardPopup } from '../components/_dashboard/publishDashCards'
//Data
import { getDashboardList} from '../config/services/publishDashboard';
import { updateUserTypeForDashboard } from '../config/services/usertype';

// ----------------------------------------------------------------------
import SearchIcon from '../assets/icons/icon_search.svg';
import Popup from '../components/Popup';
import { useLocation } from "react-router-dom";
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';


export default function PublishedDashboardList(props) {
  const queryParams = useLocation().search;
  let currentPage = new URLSearchParams(queryParams).get('pageNo');

  const [dashboardList, setDashboardList] = useState([]);
  const [dashboardsTotalCount, setDashboardTotalCount] = useState(0)
  const [search, setSearchValue] = useState('')
  const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
  const [loader, setLoading] = useState(false)
  const [pageNo, setPagination] = useState(currentPage ? parseInt(currentPage) : 1)
  //const [searchParams, setSearchParams] = useSearchParams()
  const [itemsPerPage, setItemsPerPage] = useState(8)
  const [restrictOption, setRestrictOption] = useState(false)
  const [openPopup,setOpenPopup] = useState(false)
  const [recordForEdit, setRecordForEdit] = useState(null)
  let totalPages = Number((dashboardsTotalCount / itemsPerPage).toFixed(0))

  const handleSearch = (e) => {
    let { value } = e.target
    setPagination(1)
    setSearchValue(value)
  }

  
  const handleSort = (params) => {
    let { sortOrder, sortKey } = params
    setSortObj({ sortKey, sortOrder })
  }

  const handleEditDashboard = (dashboard) => {
    setOpenPopup(true)  
    setRecordForEdit(dashboard)
  }

 const submitHandler = (params) => {
     updateUserTypeForDashboard(params)
    .then(res=> {
      if(res?.message) {
        toast.success(res.message)
        setOpenPopup(false)
        fetchDashboardList()
      }
      else if(!res?.status?.statusCode && res?.data?.error?.errors?.length) {
          toast.error(res?.data?.error?.errors[0]?.errorMessage)
      }
      else if (!res?.status?.statusCode) {
        toast.error(res?.data?.error?.errorMessage)
      }
    })    
    
}

  const handlePagination = (e, pageNumber) => {
    setPagination(pageNumber)
    //setSearchParams({ pageNo: pageNumber })
  }

  const fetchDashboardList = () => {
    let params = { pageNo: (currentPage || pageNo) - 1, count: itemsPerPage, search, ...sortObj }
    if (props?.favouriteFilter === true) {
      params.favouriteFilter = true
    }

    setLoading(true)
    getDashboardList(params)
      .then((res) => {
        setDashboardList(res?.result);
        setDashboardTotalCount(res?.totalCount)
        setLoading(false)
      });
  }

  useEffect(() => fetchDashboardList(), [search, sortObj, pageNo, itemsPerPage]);
  

  return (
    <Page title="Extramarks | Report-Engine" className="main-container">
      <Container className="table_max_width">
        <Grid container alignItems="left" className="dashboard-header" justifyContent="flex-start" mb={2} spacing={2.5}>
          <Grid item md={6} sm={4} xs={12}>
            <TextField className={`inputRounded search-input`} type="search"
              placeholder="Search By Dashboard Name"
              onChange={handleSearch}
              InputLabelProps={{ style: { ...({ top: `${-7}px` }) } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchIcon} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item md={3} sm={4} xs={12} >
            <DashboardSort className="cm_ui_sort_button dashboard_sort width-100" handleSort={handleSort} />
          </Grid>
        </Grid>


        {loader && <Loader />}

        {dashboardList?.length ?
          <DashboardList dashboards={dashboardList} 
            pageNo={pageNo} handleEditDashboard={handleEditDashboard} />
          : <Alert severity="error">No Content Available!</Alert>}

          </Container>

      {
        dashboardList?.length ?
          <div className='center cm_pagination'>
            <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo}
          />
          </div>
          : null
      }

     
      <Popup
                title={"Edit Published Dashboard"}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <PublishedDashboardPopup
                    recordForEdit={recordForEdit}
                    setOpenPopup={setOpenPopup}
                    submitHandler={submitHandler}
                />
            </Popup>


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={restrictOption}
        onClose={() => setRestrictOption(false)}
        closeAfterTransition
      >
        <Fade in={restrictOption}>
          <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">
            <Box className="modal-content-simple text-center" sx={{ p: '1rem !important' }}>
              <ErrorOutlineSharpIcon color="primary" />
              <Typography variant="subtitle1" className="text-plain font-weight-normal">To use Custom Reports Feature, Switch to Desktop screen</Typography>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Page>
  );
}
